import React from 'react';
import { PageIntro } from './PageIntro';
import { PageGLP1Overview } from './PageGLP1Overview';
import { PageGLP1Overview2 } from './PageGLP1Overview2';
import { PageGLP1Overview3 } from './PageGLP1Overview3';
import { PageGutSide } from './PageGutSide';
import { PageBrainSide } from './PageBrainSide';
import { Page1 } from './Page1';
import { PageTOC } from './PageTOC';
import { PageCopyright } from './PageCopyright';
import { DividerMedication } from './DividerMedication';
import { DividerFundamentals } from './DividerFundamentals';
import { DividerSupplements } from './DividerSupplements';
import { PageDoseManagement } from './PageDoseManagement';
import { PageDoseManagement2 } from './PageDoseManagement2';
import { Page2 } from './Page2';
import { Page2b } from './Page2b';
import { PageContext } from './PageContext';
import { PageEssentialsDivider } from './PageEssentialsDivider';
import { Page3 } from './Page3';
import { Page4 } from './Page4';
import { Page5 } from './Page5';
import { Page5b } from './Page5b';
import { Page6 } from './Page6';
import { Page7 } from './Page7';
import { Page8 } from './Page8';
import { Page9 } from './Page9';
import { Page10 } from './Page10';
import { Page11 } from './Page11';
import { Page12 } from './Page12';
import { PageMealTiming } from './PageMealTiming';
import { PageSupplementQuality } from './PageSupplementQuality';
import { PageHydration } from './PageHydration';
import { PageSleep } from './PageSleep';
import { DividerSideEffects } from './DividerSideEffects';
import { PageAcuteSideEffects } from './PageAcuteSideEffects';
import { PageChronicSideEffects } from './PageChronicSideEffects';
import { PageAlcohol } from './PageAlcohol';
import { PagePlateaus } from './PagePlateaus';
import { DividerLookingAhead } from './DividerLookingAhead';
import { PageTransitioning } from './PageTransitioning';
import { PageOutro } from './PageOutro';
import { PageOutro2 } from './PageOutro2';
import { PageAboutAuthor2 } from './PageAboutAuthor2';
import { FoodPhoto1 } from './FoodPhoto1';
import { FoodPhoto2 } from './FoodPhoto2';
import { FoodPhoto3 } from './FoodPhoto3';
import { FoodPhoto4 } from './FoodPhoto4';
import { FoodPhoto5 } from './FoodPhoto5';
// Supplement Pages
import { SupplementWheyProtein } from './SupplementWheyProtein';
import { SupplementMultiVitamin } from './SupplementMultiVitamin';
import { SupplementVitaminD } from './SupplementVitaminD';
import { SupplementCoQ10 } from './SupplementCoQ10';
import { SupplementElectrolytes } from './SupplementElectrolytes';
import { SupplementCreatine } from './SupplementCreatine';
import { SupplementSleepSupport } from './SupplementSleepSupport';
import { SupplementMagnesium } from './SupplementMagnesium';
import { SupplementAshwagandha } from './SupplementAshwagandha';
import { SupplementGlutathione } from './SupplementGlutathione';
import { SupplementOmega3 } from './SupplementOmega3';
import { SupplementAshwagandhaMuscle } from './SupplementAshwagandhaMuscle';
import { Printer, Lock, ShoppingCart } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
export function Booklet() {
  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === '1';
  if (isPreview) {
    return <div className="print-container min-h-screen bg-bodybg py-12 flex flex-col items-center gap-12 overflow-y-auto" data-id="element-137">
        <Page1 data-id="element-138" />
        <PageCopyright data-id="element-139" />
        <PageIntro data-id="element-140" />
        <PageTOC data-id="element-141" />

        {/* Preview end gate */}
        <div className="w-full max-w-3xl mx-auto px-6 py-16 text-center" data-id="element-142">
          <Lock className="w-10 h-10 text-tealslate mx-auto mb-6" data-id="element-143" />
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.3em] mb-4" data-id="element-144">
            End of Preview
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-5 leading-tight" data-id="element-145">
            That's the first taste.
          </h2>
          <p className="text-base text-[#D8D8D0] leading-relaxed max-w-xl mx-auto mb-10" data-id="element-146">
            The full GLP-1 Nutrition Guide includes 40+ pages of practical
            frameworks for protecting muscle, managing side effects, dialing in
            supplements, and building habits that outlast the prescription.
          </p>
          <Link to="/books" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-tealslate text-white text-[11px] font-bold uppercase tracking-[0.2em] hover:bg-tealslate/80 transition-colors" data-id="element-147">
            <ShoppingCart className="w-4 h-4" data-id="element-148" />
            Get the Full Guide
          </Link>
        </div>
      </div>;
  }
  return <>
      <button onClick={() => window.print()} className="print-button fixed top-6 right-6 z-50 bg-tealslate hover:bg-tealslate/80 text-white px-5 py-3 flex items-center gap-2 font-bold text-sm uppercase tracking-wider shadow-lg transition-colors" data-id="element-149">
        <Printer className="w-5 h-5" data-id="element-150" />
        Save as PDF
      </button>
      <div className="print-container min-h-screen bg-bodybg py-12 flex flex-col items-center gap-12 overflow-y-auto" data-id="element-151">
        <Page1 data-id="element-152" />
        <PageCopyright data-id="element-153" />
        <PageIntro data-id="element-154" />
        <PageTOC data-id="element-155" />
        {/* Part One: Understanding Your Medication */}
        <DividerMedication data-id="element-156" />
        <PageGLP1Overview data-id="element-157" />
        <PageGLP1Overview2 data-id="element-158" />
        <PageGLP1Overview3 data-id="element-159" />
        <PageGutSide data-id="element-160" />
        <PageBrainSide data-id="element-161" />
        <PageDoseManagement data-id="element-162" />
        <PageDoseManagement2 data-id="element-163" />
        <FoodPhoto1 data-id="element-164" />
        {/* Part Two: The Fundamentals */}
        <DividerFundamentals data-id="element-165" />
        <Page2 data-id="element-166" />
        <Page2b data-id="element-167" />
        <PageContext data-id="element-168" />
        {/* Part Three: The Essentials */}
        <PageEssentialsDivider data-id="element-169" />
        <Page3 data-id="element-170" />
        <Page4 data-id="element-171" />
        <FoodPhoto2 data-id="element-172" />
        <Page6 data-id="element-173" />
        <Page7 data-id="element-174" />
        <Page8 data-id="element-175" />
        <PageHydration data-id="element-176" />
        <FoodPhoto3 data-id="element-177" />
        <PageMealTiming data-id="element-178" />
        <Page5 data-id="element-179" />
        <Page5b data-id="element-180" />
        <Page9 data-id="element-181" />
        <Page10 data-id="element-182" />
        <PageSleep data-id="element-183" />
        <Page11 data-id="element-184" />
        {/* Part Four: Supplements */}
        <DividerSupplements data-id="element-185" />
        <PageSupplementQuality data-id="element-186" />
        <SupplementWheyProtein data-id="element-187" />
        <SupplementMultiVitamin data-id="element-188" />
        <SupplementVitaminD data-id="element-189" />
        <SupplementCoQ10 data-id="element-190" />
        <SupplementOmega3 data-id="element-191" />
        <SupplementElectrolytes data-id="element-192" />
        <SupplementCreatine data-id="element-193" />
        <SupplementAshwagandhaMuscle data-id="element-194" />
        <SupplementSleepSupport data-id="element-195" />
        <SupplementMagnesium data-id="element-196" />
        <SupplementAshwagandha data-id="element-197" />
        <SupplementGlutathione data-id="element-198" />
        <FoodPhoto4 data-id="element-199" />
        {/* Part Five: Side Effects & Challenges */}
        <DividerSideEffects data-id="element-200" />
        <PageAcuteSideEffects data-id="element-201" />
        <PageChronicSideEffects data-id="element-202" />
        <PageAlcohol data-id="element-203" />
        <PagePlateaus data-id="element-204" />
        <FoodPhoto5 data-id="element-205" />
        {/* Part Six: Looking Ahead */}
        <DividerLookingAhead data-id="element-206" />
        <PageTransitioning data-id="element-207" />
        <PageOutro2 data-id="element-208" />
        <PageAboutAuthor2 data-id="element-209" />
        <Page12 data-id="element-210" />
      </div>
    </>;
}